var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.286 6.115H16.57V4.287a.426.426 0 00-.428-.422h-1.429a.427.427 0 00-.428.422v1.828H9.714V4.287a.427.427 0 00-.428-.422H7.857a.427.427 0 00-.428.422v1.828H5.714C4.768 6.115 4 6.87 4 7.802v12.375c0 .932.768 1.688 1.714 1.688h12.572c.946 0 1.714-.756 1.714-1.688V7.802c0-.931-.768-1.687-1.714-1.687zm-.215 14.062H5.93a.213.213 0 01-.215-.21V9.49h12.572v10.476c0 .116-.097.211-.215.211z",
    fill: "#777"
  })));
}

export default SvgCalendarOff;